<template>
  <div
    class="m-assembly new top-nav"
    v-if="
      extras.groupIntroductionDisplay &&
      extras.groupIntroductionDisplay.display == 1
    "
    :style="{
      background:
        extras.introBg.colorOrBg == 'color'
          ? extras.introBg.color
          : 'url(' + extras.introBg.src + ')',
    }"
    id="introduction"
  >
    <WapTitle
      v-if="extras && extras.IntroTitle.display == 1"
      :title="extras.IntroTitle.mainTitle || title"
      :en="extras.IntroTitle.subTitle || 'Introduction'"
      :extras="extras"
    />
    <div
      class="no-data"
      v-if="seminarInfo.descWap.length == 0 && seminarInfo.desc.length == 0"
    >
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">暂无数据</div>
    </div>
    <div
      class="g-intrd-html"
      v-html="seminarInfo.descWap ? seminarInfo.descWap : seminarInfo.desc"
      :style="{
        color: extras.introductionDescription
          ? extras.introductionDescription.color
          : '',
        backgroundColor: extras.introductionDescription
          ? extras.introductionDescription.bg
          : '',
      }"
    ></div>
  </div>
</template>

<script>
import WapTitle from "@/components/wap/Title.vue";

export default {
  components: {
    WapTitle,
  },
  props: {
    seminarInfo: Object,
    extras: Object,
  },
  data() {
    return {
      title: "大会介绍",
      icon: require("@/assets/images/wap/dahui.png"),
    };
  },
};
</script>

<style scoped></style>
